import React from "react";
import {
    Row,
    Col,
    Steps,
    Card,
    Select,
    Carousel,
    Input,
    Form
} from 'antd';
import { Map, Marker, InfoWindow } from 'google-maps-react';
import place_red from '../../image/3.png';
import { getStoreList_map } from "./service";
import moment from 'moment';
import {
    ShopTwoTone,
    UserOutlined,
    PhoneTwoTone,
    HomeTwoTone,
    StarTwoTone
} from '@ant-design/icons';
import MapContainer from "./MapContainer";

const { Option } = Select;
const { Meta } = Card;
const { form } = Form;
// import 'moment/locale/th';
// import locale from 'antd/lib/locale/th';
const people = [
    {
        name: 'James',
        age: 31,
    },
    {
        name: 'John',
        age: 45,
    },
    {
        name: 'Paul',
        age: 65,
    },
    {
        name: 'Ringo',
        age: 49,
    },
    {
        name: 'George',
        age: 34,
    }
];
var place_red_resize = null;
const { Step } = Steps;
const google = window.google
const mapStyles = {
    width: '100%',
    height: '100%',
    // position: 'relative',
    // overflow: 'hidden',
    padding: '30px'
};
var directionsService = null;
var directionsDisplay = null;
const dateFormat = 'YYYY-MM-DD';
const contentStyle = {
    height: '160px',
    color: '#fff',
    lineHeight: '160px',
    textAlign: 'center',
    background: '#364d79',
};
var bounds = null;

class ViewShop extends React.Component {
    state = {
        markers: [],
        // empCd: this.props.location.saleDetail.empCd,
        // empCd: '900001',
        date: moment().format(dateFormat),
        dateString: null,
        data: [],
        myMap: null,
        showingInfoWindow: false,
        activeMarker: {},
        activeMarkerCard: false,
        shopSearch: []
    };

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        getStoreList_map().then(res => {
            if (res && res.status === 200) {
                this.setState({
                    data: res.data.info,
                    shopSearch: res.data.info,
                })
            }
        })
    }

    dd = () => {
        // console.log(this.state);
        console.log("this.state", this.state)
    }

    showMarkers = () => {
        return this.state.shopSearch.map((store, index) => {
            // console.log("store", store)

            return <Marker key={index} id={index} position={{
                lat: store.latitude,
                lng: store.longitude
            }}
                valuename={store.store_name}
                valuephone={store.phone1}
                valueaddress={store.full_address}
                valuefn={store.firstName_th}
                valueln={store.lastName_th}
                valuestore={store}
                onClick={this.onMarkerClick}
            />

        })
    }

    onMarkerClick = (props, marker) => {
        // console.log("marker", marker)
        this.setState({
            activeMarker: marker,
            activeMarkerCard: true,
            showingInfoWindow: true
        });
    };
    onInfoWindowClose = () => {
        this.setState({
            activeMarker: null,
            activeMarkerCard: false,
            showingInfoWindow: false
        });
    }


    temp_shop = (e) => {
        // console.log("e", e.target.value)
        var value = e.target.value
        this.shopSearchResult(value)
    }

    shopSearchResult = (value) => {

        let data = this.state.data
        var newData = []
        data.filter(data => data.store_name.includes(value)).map(filteredStore => {
            // console.log("filteredStore", filteredStore)
            newData.push(filteredStore)
        })
        // console.log("newData", newData)
        this.setState({
            shopSearch: newData
        })
    }

    onChange = (value) => {
        let data = this.state.data
        var newData = []
        // console.log(`selected ${value}`);
        if (value == 'all') {
            this.setState({
                shopSearch: data
            })
        } else {
            data.filter(data => data.saleAreaCd.includes(value)).map(filteredStore => {
                // console.log("filteredStore", filteredStore)
                newData.push(filteredStore)
            })
            this.setState({
                shopSearch: newData
            })
        }
    }

    onBlur() {
        console.log('blur');
    }

    onFocus() {
        console.log('focus');
    }

    onSearch(val) {
        console.log('search:', val);
    }

    render() {
        // const array = [
        //     { id: 3, name: 'Central Microscopy', fiscalYear: 2018 },
        //     { id: 5, name: 'Crystallography Facility', fiscalYear: 2018 },
        //     { id: 3, name: 'Central Microscopy', fiscalYear: 2017 },
        //     { id: 5, name: 'Crystallography Facility', fiscalYear: 2017 }
        // ];

        const array = this.state.data
        const shopSearchChk = this.state.shopSearch
        const result = Array.from(new Set(array.map(s => s.saleAreaCd)))
            .map(saleAreaCd => {
                return {
                    saleAreaCd: saleAreaCd,
                    saleAreaDesc: array.find(s => s.saleAreaCd === saleAreaCd).saleAreaDesc
                }
            })

        console.log(result)
        // if (shopSearchChk.length > 0) {
            return (
                <>
                    <h2>View Shops Map </h2>

                    {/* <div onClick={this.dd}>dd</div> */}
                    {/* {
                        people.filter(person => person.age === 35).map(filteredPerson => (
                            <li>
                                {filteredPerson.name}
                            </li>
                        ))
                    } */}
                    <Row gutter={[0, 0]}>
                        <Col span={18}>
                            <div style={{ height: '500px' }}>
                                {/* {this.state.data.length > 0 && <MapContainer data={this.state.data}/>} */}



                                <Map
                                    google={google}
                                    zoom={10}
                                    style={mapStyles}
                                    initialCenter={{ lat: 13.7278956, lng: 100.5241235 }}
                                    disableDefaultUI
                                    zoomControl
                                >
                                    {this.state.data.length > 0 && this.showMarkers()}

                                    <InfoWindow
                                        marker={this.state.activeMarker}
                                        onClose={this.onInfoWindowClose}
                                        visible={this.state.showingInfoWindow}>

                                        {this.state.activeMarker &&
                                            <div>
                                                <h1>{this.state.activeMarker.valuename}</h1>
                                                <p>{this.state.activeMarker.valuephone}</p>
                                                <p>{this.state.activeMarker.valueaddress}</p>
                                                <p>{this.state.activeMarker.valuefn}{' '}{this.state.activeMarker.valueln}</p>
                                            </div>
                                        }

                                    </InfoWindow>
                                </Map>

                            </div>
                        </Col>
                        <Col span={6} style={{ padding: '0px 15px 0px 15px' }}>
                            <Select
                                showSearch
                                // style={{ width: 200 }}
                                style={{ width: '100%', marginBottom: '5px' }}
                                placeholder="เลือกเขตการขาย"
                                optionFilterProp="children"
                                onChange={this.onChange}
                                onFocus={this.onFocus}
                                onBlur={this.onBlur}
                                onSearch={this.onSearch}
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                <Option value="all" selected>ทั้งหมด</Option>
                                {result.map((op, index) =>
                                    <Option key={index} value={op.saleAreaCd}>{op.saleAreaDesc}</Option>
                                )}
                            </Select>
                            <Input.Search allowClear
                                size='middle'
                                style={{ width: '100%', marginBottom: '15px', padding: '0 auto' }}
                                placeholder="ค้นหาร้านค้า"
                                onChange={this.temp_shop}
                            />

                            {this.state.activeMarkerCard ?
                                <>
                                    <Card
                                        title={this.state.activeMarker.valuestore.store_name}
                                        // hoverable
                                        style={{ width: '100%' }}
                                        cover={
                                            <Carousel autoplay>
                                                <div>
                                                    <img alt="" width="100%" height="230px" src={this.state.activeMarker.valuestore.image[0]} />
                                                </div>
                                            </Carousel>
                                        }
                                    >
                                        {/* <Meta title={this.state.activeMarker.valuename} /> */}
                                        <StarTwoTone twoToneColor="#eb2f96" />
                                        ร้านค้า:
                                        <StarTwoTone twoToneColor="#eb2f96" />
                                        <p align="left"><ShopTwoTone /> {this.state.activeMarker.valuestore.store_name}</p>
                                        <p align="left"><UserOutlined twoToneColor="#eb2f96" /> {this.state.activeMarker.valuestore.firstName_th}{' '}{this.state.activeMarker.valuestore.lastName_th}</p>
                                        <p align="left"><PhoneTwoTone /> {this.state.activeMarker.valuestore.phone1}</p>
                                        <p align="left"><HomeTwoTone /> {this.state.activeMarker.valuestore.full_address}</p>
                                        <StarTwoTone twoToneColor="#eb2f96" />
                                        ผู้ติดต่อ:
                                        <StarTwoTone twoToneColor="#eb2f96" />
                                        <p align="left"><UserOutlined /> {this.state.activeMarker.valuestore.contact_name}</p>
                                        <p align="left"><PhoneTwoTone /> {this.state.activeMarker.valuestore.contact_phone}</p>

                                    </Card>
                                </>
                                :
                                // <Card loading title="กรุณาเลือกร้านค้า" style={{ width: '100%' }}>

                                // </Card>
                                <>
                                </>
                            }
                        </Col>
                    </Row>

                    {/* </div> */}
                </>
            )
        // } else {
        //     return (
        //         <>
        //             loading
        //         </>
        //     )
        // }
    }
}

export default ViewShop;
